export function getCookie(name: string): string | null {
    const cookieString = document.cookie;
    if (!cookieString) return null;

    const cookies = cookieString.split(";");
    for (let cookie of cookies) {
        cookie = cookie.trim();

        if (cookie.startsWith(name + "=")) {
            return decodeURIComponent(cookie.substring(name.length + 1));
        }
    }

    return "";
}